import { render, staticRenderFns } from "./DynamicImage.vue?vue&type=template&id=d0b583da&scoped=true&"
import script from "./DynamicImage.vue?vue&type=script&lang=js&"
export * from "./DynamicImage.vue?vue&type=script&lang=js&"
import style0 from "./DynamicImage.vue?vue&type=style&index=0&id=d0b583da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b583da",
  null
  
)

export default component.exports